import { useAuthContext } from "providers/Auth";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";

const getUnitAvailabilityDeniedTooltip = (unit: string) =>
  `You don't have permission to change ${unit} availability`;

export const useUnitAvailabilityPermission = () => {
  const { permissions } = useAuthContext();
  const { unit } = useUnitsPropertiesDictionary();

  const canChangeUnitAvailability = permissions.canChangeUnitAvailability;

  return {
    canChangeUnitAvailability,
    unitAvailabilityDeniedTooltip: canChangeUnitAvailability
      ? undefined
      : getUnitAvailabilityDeniedTooltip(unit)
  };
};
